import React from 'react';
import { styled } from '@mui/material/styles';
import Add from "@mui/icons-material/Add";
import { Button } from '../Button';
import { Badge } from './Badge';
const SellBanner = ({ isShowBadge = true, productTitle, productImage, handleClick }) => {
    return (React.createElement(Container, null,
        React.createElement(TitleAndImageContainer, null,
            React.createElement(TitleContainer, null,
                isShowBadge && (React.createElement(Badge, null)),
                React.createElement(StyledTitle, null, "Vendez-le-v\u00F4tre"),
                React.createElement(StyledSubTitle, null,
                    "Paiement garanti ",
                    React.createElement("br", null),
                    " Exp\u00E9dition gratuite"),
                React.createElement(StyledDescription, null, productTitle)),
            productImage && (React.createElement(ImageContainer, { "data-qa": "badge-img" },
                React.createElement("img", { src: productImage, width: 114, height: 114 })))),
        React.createElement(ButtonContainer, null,
            React.createElement(Button, { color: "seller", variant: "contained", startIcon: React.createElement(Add, null), onClick: handleClick, sx: { width: '-webkit-fill-available;' } }, "D\u00E9poser une annonce"))));
};
const Container = styled('div')({
    display: 'flex',
    padding: '16px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    borderRadius: '8px',
    border: "1px solid var(--grey-color-grey-200, #EBEBEB)",
    background: '#fff'
});
const TitleAndImageContainer = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '-webkit-fill-available'
});
const TitleContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    marginRight: '16px'
});
const StyledTitle = styled('span')({
    paddingTop: '10px',
    color: '#005300',
    fontSize: '20px',
    fontWeight: 400
});
const StyledSubTitle = styled('span')({
    color: '#005300',
    fontSize: '14px',
    fontWeight: 400,
    paddingTop: '10px',
});
const StyledDescription = styled('div')({
    color: '#4D4D4D',
    fontSize: '12px',
    fontWeight: 400,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    width: '163px',
    paddingTop: '10px',
});
const ImageContainer = styled('div')({
    borderRadius: '8px',
    border: '1px solid var(--grey-color-grey-200, #EBEBEB)',
    background: 'var(--white-color-white, #FFF)',
    padding: '7px'
});
const ButtonContainer = styled('div')({
    display: 'flex',
    width: '-webkit-fill-available'
});
export default SellBanner;
